"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextField = exports.TextFieldComponent = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var ErrorMessage_1 = require("../ErrorMessage");
var HelpText_1 = require("../HelpText");
var Icon_1 = require("../Icon");
var InputLabel_1 = require("../InputLabel");
/**
 * TextField
 */
var TextFieldComponent = function (props) {
    // Extract known attributes from props into variables
    var className = props.className, // Capture the classname so it cannot be applied to the textfield
    enableClearText = props.enableClearText, children = props.children, errormessage = props.errormessage, forwardRef = props.forwardRef, helptext = props.helptext, id = props.id, isOptional = props.isOptional, isValid = props.isValid, label = props.label, maxLength = props.maxLength, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, required = props.required, tooltipText = props.tooltipText, type = props.type, value = props.value, attributes = __rest(props, ["className", "enableClearText", "children", "errormessage", "forwardRef", "helptext", "id", "isOptional", "isValid", "label", "maxLength", "name", "onBlur", "onChange", "onFocus", "required", "tooltipText", "type", "value"]) // tslint:disable-line
    ;
    attributes.id = id;
    attributes.className = 'form-control';
    attributes.name = name ? name : id;
    var modRef = (React.useRef());
    var labelProps = {
        id: id,
        isOptional: isOptional,
        label: label,
        tooltipText: tooltipText,
    };
    if (!attributes.placeholder && type === 'inline-date') {
        attributes.placeholder = 'DD/MM/YYYY';
        attributes.type = 'text';
    }
    else {
        attributes.type = type;
    }
    // Add maximum length
    if (typeof maxLength === 'number' && maxLength > 0) {
        attributes.maxLength = maxLength;
    }
    if (typeof onBlur === 'function') {
        attributes.onBlur = onBlur;
    }
    if (typeof onChange === 'function') {
        attributes.value = typeof maxLength === 'undefined'
            ? value
            : String(value).slice(0, maxLength);
        attributes.onChange = function (e) {
            // @ts-ignore
            onChange(attributes.name, e.target.value, e);
        };
    }
    else {
        attributes.defaultValue = typeof maxLength === 'undefined'
            ? value
            : String(value).slice(0, maxLength);
    }
    if (typeof onFocus === 'function') {
        attributes.onFocus = onFocus;
    }
    if (typeof required === 'boolean' && required === true) {
        attributes['aria-required'] = true;
    }
    var ErrorMessageComponent;
    var HelpTextComponent;
    if (typeof isValid === 'boolean' && isValid === false) {
        // Invalid
        attributes.className += ' is-invalid';
        attributes['aria-invalid'] = true;
        // Invalid with error message
        if (errormessage) {
            attributes['aria-describedby'] = id + "-errormessage";
            ErrorMessageComponent = (React.createElement(ErrorMessage_1.ErrorMessage, { id: id, message: errormessage }));
        }
    }
    else if (helptext) {
        attributes['aria-describedby'] = id + "-helptext";
        HelpTextComponent = (React.createElement(HelpText_1.HelpText, { id: id }, helptext));
    }
    var onClearCLick = function () {
        modRef.current.children[0].defaultValue = '';
        modRef.current.children[0].value = '';
    };
    var iconAttributes = {
        className: 'btn-action-formfield',
        onClick: onClearCLick,
        screenreader: 'clear text',
        symbol: 'controlClose24',
    };
    var renderInputButton = function () {
        if (enableClearText) {
            return (React.createElement("div", { className: "form-field__with-btn", ref: modRef },
                React.createElement("input", __assign({}, attributes, { ref: forwardRef })),
                React.createElement(Icon_1.Icon, __assign({}, iconAttributes, { type: "css" })),
                HelpTextComponent,
                ErrorMessageComponent));
        }
        else {
            return (React.createElement(React.Fragment, null,
                React.createElement("input", __assign({}, attributes, { ref: forwardRef })),
                HelpTextComponent,
                ErrorMessageComponent));
        }
    };
    return (React.createElement("div", { className: "form-group" },
        React.createElement(InputLabel_1.InputLabel, __assign({}, labelProps)),
        renderInputButton()));
};
exports.TextFieldComponent = TextFieldComponent;
exports.TextFieldComponent.defaultProps = {
    isValid: true,
    type: 'text',
};
exports.TextFieldComponent.displayName = 'TextField';
// tslint:disable no-string-literal
exports.TextFieldComponent['propTypes'] = {
    enableClearText: PropTypes.bool,
    errormessage: PropTypes.string,
    helptext: PropTypes.any,
    id: PropTypes.string.isRequired,
    isOptional: PropTypes.bool,
    isValid: PropTypes.bool,
    label: PropTypes.string.isRequired,
    maxLength: PropTypes.number,
    /* Name will default to ID if not provided. ID is required for linking label with input */
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    placeholder: PropTypes.string,
    required: PropTypes.bool,
    tooltipText: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.string.isRequired,
};
// tslint:enable no-string-literal
exports.TextField = React.forwardRef(function (props, ref) {
    return (React.createElement(exports.TextFieldComponent, __assign({}, props, { forwardRef: ref })));
});
exports.TextField.displayName = 'TextField';
